import React from "react";
import { useSelector } from "../../store";

const Checkmark = ({ selected, onClick }) => (
	<div
		onClick={onClick}
		style={
			selected
				? { left: "4px", top: "4px", position: "absolute", zIndex: "1" }
				: { display: "none" }
		}
	>
		<svg
			style={{ fill: "white", position: "absolute" }}
			width="24px"
			height="24px"
		>
			<circle cx="12.5" cy="12.2" r="8.292" />
		</svg>
		<svg
			style={{ fill: "#06befa", position: "absolute" }}
			width="24px"
			height="24px"
		>
			<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
		</svg>
	</div>
);

const imgStyle = {
	transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const selectedImgStyle = {
	transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
	transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const cont = {
	//   backgroundColor: "#eee",
	cursor: "pointer",
	overflow: "hidden",
	position: "relative"
};

const SelectedImage = ({
	index,
	photo,
	margin,
	direction,
	top,
	left,
	selected,
	onSelect,
	onClick
}) => {
	//   const [isSelected, setIsSelected] = useState(selected);
	const isAdmin = useSelector(state => state.isAdmin);
	const isSelected = selected;
	//calculate x,y scale
	const sx = (100 - (30 / photo.width) * 100) / 100;
	const sy = (100 - (30 / photo.height) * 100) / 100;
	selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

	if (direction === "column") {
		cont.position = "absolute";
		cont.left = left;
		cont.top = top;
	}

	const handleOnClick = e => {
		if (e.ctrlKey) {
			if (onSelect) onSelect(e, photo, !isSelected);
		} else {
			if (onClick) onClick(e, photo)
		}
	};


	//   useEffect(() => {
	//     setIsSelected(selected);
	//   }, [selected]);

	// console.log(`photo`, photo)
	const aColors = photo?.color?.split(',')
	// console.log(`aColors`, aColors)
	const clr1 = (aColors.length > 0) ? aColors[0] : '#000000'
	const clr2 = (aColors.length > 1) ? aColors[1] : '#00000000'
	const bg = { background: `linear-gradient(to right, ${clr1},${clr2})` };

	return (
		<div
			style={{ margin, height: photo.height, width: photo.width, ...cont, ...bg }}
			className={!isSelected ? "SelectedImage not-selected" : "SelectedImage"}
		>
			<Checkmark selected={isSelected ? true : false} />
			{(photo.thumbsUp>0)&&<div className="thumbsup">♥ <small>{photo.thumbsUp}</small></div>}
			{isAdmin && photo.nsfw > 0 ? <div style={{ position: 'absolute', top: '5px', right: '5px', fontSize: '10px', backgroundColor: '#DD000099' }}>nsfw</div> : null}
			<img
				alt={photo.title}
				loading="lazy"
				style={
					isSelected ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
				}
				{...photo}
				onClick={handleOnClick}
			/>
			{isAdmin && <div className="infobox">
				<div className="minitags">{photo?.tags?.split(',').join(', ')}</div>
				<div className="colors">
					{aColors.map(clr => {
						return (<div key={clr} className="swat" style={{ backgroundColor: clr }}></div>)
					})}
				</div>
			</div>}
			{/* <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style> */}

		</div>
	);
};

export default SelectedImage;